Ext.define('SA.view.sidebar.data.ViewDataFoldersBrowserParams', {
    constructor({censusRelease, dataset, editionOption, path}) {
        this.censusRelease = censusRelease;
        this.dataset = dataset;
        this.editionOption = editionOption;
        this.path = path;
    },

    getCensusRelease() {
        return this.censusRelease;
    },

    getDataset() {
        return this.dataset;
    },

    getEditionOption() {
        return this.editionOption;
    },

    getPath() {
        return this.path;
    }
});